'use client';

import { useState } from 'react';
import { X } from 'lucide-react';
import Link from 'next/link';
import { Button } from '@/components/ui/Button';

interface OptInModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

export function OptInModal({ isOpen, onClose, onAccept }: OptInModalProps) {
  const [isChecked, setIsChecked] = useState(false);

  if (!isOpen) return null;

  const handleAccept = () => {
    if (isChecked) {
      onAccept();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div
          className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 animate-in fade-in-0 zoom-in-95 duration-200"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="optin-modal-title"
        >
          {/* Bouton fermer */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors"
            aria-label="Fermer"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Contenu */}
          <div className="mt-2">
            {/* Information cookies */}
            <p className="text-base text-black mb-4">
              Ce site n&apos;utilise aucun cookie
            </p>

            <div className="flex items-start gap-3 mb-6">
              <input
                type="checkbox"
                id="opt-in-checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                className="mt-1 w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
              />
              <label
                htmlFor="opt-in-checkbox"
                className="text-base text-black leading-relaxed cursor-pointer"
              >
                En envoyant des messages à VictorIA, j&apos;accepte les{' '}
                <Link
                  href="/conditions-generales-utilisation"
                  className="text-primary underline hover:text-primary/80"
                  onClick={(e) => e.stopPropagation()}
                >
                  Conditions Générales d&apos;Utilisation
                </Link>
                , les{' '}
                <Link
                  href="/mentions-legales"
                  className="text-primary underline hover:text-primary/80"
                  onClick={(e) => e.stopPropagation()}
                >
                  Mentions légales
                </Link>
                {' '}et la{' '}
                <Link
                  href="/charte-ethique"
                  className="text-primary underline hover:text-primary/80"
                  onClick={(e) => e.stopPropagation()}
                >
                  Charte éthique
                </Link>
                .
              </label>
            </div>

            {/* Bouton Valider */}
            <Button
              onClick={handleAccept}
              disabled={!isChecked}
              className={`w-full bg-primary text-white rounded-lg py-3 px-6 font-medium transition-all ${
                isChecked
                  ? 'hover:bg-primary/90 cursor-pointer'
                  : 'opacity-50 cursor-not-allowed'
              }`}
            >
              Valider
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
